function parseIsoDate(iso: string): {
  day: number;
  month: number;
  year: number;
} {
  const parts = iso.split("-").map(Number);
  const year = parts[0] ?? 0;
  const month = parts[1] ?? 1;
  const day = parts[2] ?? 1;
  return { day, month: month - 1, year };
}

/** "09/10/2026" */
export function formatDate(iso: string): string {
  const { day, month, year } = parseIsoDate(iso);
  return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(2, "0")}/${year}`;
}

/** "01/10/2026 s/d 07/10/2026" */
export function formatPeriod(startIso: string, endIso: string): string {
  return `${formatDate(startIso)} s/d ${formatDate(endIso)}`;
}
